var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9472 5.45312H7.79382H4.05382C3.41382 5.45312 3.09382 6.22646 3.54716 6.67979L7.00049 10.1331C7.55382 10.6865 8.45382 10.6865 9.00716 10.1331L10.3205 8.81979L12.4605 6.67979C12.9072 6.22646 12.5872 5.45312 11.9472 5.45312Z",
    fill: "#393C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic-arrow-down.1973ec8e0b0b9a948d4736f24ba648f1.svg";
export { ForwardRef as ReactComponent };